(function () {
  if (window.__rwReveal) return;
  window.__rwReveal = true;
  if (!matchMedia('(prefers-reduced-motion: no-preference)').matches) return;
  var hasIO = 'IntersectionObserver' in window;
  var fine = matchMedia('(hover: hover) and (pointer: fine)').matches;

  function countUp(el, i) {
    var txt = el.textContent, m = txt.match(/\d{1,3}(,\d{3})+|\d{4,}/);
    if (!m) return;
    var target = parseInt(m[0].replace(/,/g, ''), 10), t0 = null;
    setTimeout(function () {
      requestAnimationFrame(function step(t) {
        t0 = t0 || t;
        var p = Math.min((t - t0) / 900, 1), e = 1 - Math.pow(1 - p, 3);
        el.textContent = p < 1 ? txt.replace(m[0], Math.round(target * e).toLocaleString('en-US')) : txt;
        if (p < 1) requestAnimationFrame(step);
      });
    }, 700 + i * 120);
  }

  function tilt(card) {
    card.addEventListener('pointermove', function (e) {
      var r = card.getBoundingClientRect();
      card.style.setProperty('--ry', (((e.clientX - r.left) / r.width - 0.5) * 6).toFixed(2) + 'deg');
      card.style.setProperty('--rx', ((0.5 - (e.clientY - r.top) / r.height) * 6).toFixed(2) + 'deg');
    });
    card.addEventListener('pointerleave', function () {
      card.style.setProperty('--rx', '0deg');
      card.style.setProperty('--ry', '0deg');
    });
  }

  function init(scope) {
    scope.querySelectorAll('.rw[data-rw-reveal]').forEach(function (root) {
      if (!hasIO) { root.classList.add('is-inview'); return; }
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        root.classList.add('is-inview');
        root.querySelectorAll('[data-countup]').forEach(countUp);
      }, { threshold: 0.25 });
      io.observe(root);
      if (fine && root.hasAttribute('data-rw-tilt')) root.querySelectorAll('.rw-card').forEach(tilt);
    });
  }

  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
